import React, { useState } from 'react';
import { useAppSelector } from '../../hooks';
import KeyPoolsList from './components/KeyPoolsList';
import ActionBar from '../layout/ActionBar';
import DisableUnusedKeys from './slideout/DisableUnusedKeys';
import KeyPoolUpload from './slideout/KeyPoolUpload';
import SlidingPane from 'react-sliding-pane';
import { usePageTitle } from '../../util/pageTitle';

function KeyPools() {
  usePageTitle(['Key pools', 'Keys']);
  const importTransactions = useAppSelector((state) => state.importTransactions);
  const [reload, setReload] = useState<any>();

  const [disableUnusedSlideoutOpen, setDisableUnusedSlideoutOpen] =
    useState(false);
  const [disableUnusedSlideoutItem, setDisableUnusedSlideoutItem] = useState<any>();

  const [uploadSlideoutOpen, setUploadSlideoutOpen] = useState(false);
  const [uploadSlideoutItem, setUploadSlideoutItem] = useState<any>();

  return (
    <>
      <ActionBar />
      <KeyPoolsList
        reload={reload}
        upload={(e, item) => {
          setUploadSlideoutItem(item);
          setUploadSlideoutOpen(true);
        }}
        importTransactions={importTransactions}
        onDisableUnused={(e, item) => {
          setDisableUnusedSlideoutItem(item);
          setDisableUnusedSlideoutOpen(true);
        }}
      />

      <SlidingPane
        isOpen={disableUnusedSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setDisableUnusedSlideoutOpen(false)}
      >
        {disableUnusedSlideoutItem ? (
          <DisableUnusedKeys
            done={() => {
              setDisableUnusedSlideoutOpen(false);
            }}
            cancel={() => setDisableUnusedSlideoutOpen(false)}
            skuId={disableUnusedSlideoutItem.skuId}
            skuName={disableUnusedSlideoutItem.skuName}
            keyWorkflowId={disableUnusedSlideoutItem.keyWorkflowId}
            keyWorkflowName={disableUnusedSlideoutItem.keyWorkflowName}
            gameName={disableUnusedSlideoutItem.gameName}
          />
        ) : null}
      </SlidingPane>

      <SlidingPane
        isOpen={uploadSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setUploadSlideoutOpen(false)}
      >
        {uploadSlideoutItem ? (
          <KeyPoolUpload
            done={() => {
              setUploadSlideoutOpen(false);
              setReload(new Date());
            }}
            cancel={() => setUploadSlideoutOpen(false)}
            gameId={uploadSlideoutItem.gameId}
            gameName={uploadSlideoutItem.gameName}
            skuId={uploadSlideoutItem.skuId}
            skuName={uploadSlideoutItem.skuName}
            keyWorkflowId={uploadSlideoutItem.keyWorkflowId}
            keyWorkflowName={uploadSlideoutItem.keyWorkflowName}
          />
        ) : null}
      </SlidingPane>
    </>
  );
}

export default KeyPools;
